import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { KPICard } from '../../components/ui/KPICard';
import { DataTable } from '../../components/ui/DataTable';
import { StatusPill } from '../../components/ui/StatusPill';
import { Button } from '../../components/ui/Button';
import { CreditCardIcon, DollarSignIcon, ClockIcon, ArrowLeftIcon, DownloadIcon } from 'lucide-react';
const payments = [{
  id: 'PAY-2026-0314-001',
  date: '2026-03-14',
  amount: '$298,500.00',
  method: 'Bank Transfer',
  status: 'Paid',
  invoices: 1
}, {
  id: 'PAY-2026-04-19-BATCH',
  date: '2026-04-19',
  amount: '$112,400.00',
  method: 'Bank Transfer',
  status: 'Scheduled',
  invoices: 1
}, {
  id: 'PAY-2026-0310-003',
  date: '2026-03-10',
  amount: '$143,200.00',
  method: 'Bank Transfer',
  status: 'Paid',
  invoices: 1
}];
export const PaymentsPage: React.FC = () => {
  const [selectedPayment, setSelectedPayment] = useState<any>(null);
  if (selectedPayment) {
    return <div className="max-w-7xl mx-auto space-y-6" data-id="element-1560">
        <Button variant="ghost" leftIcon={<ArrowLeftIcon className="w-4 h-4" data-id="element-1562" />} onClick={() => setSelectedPayment(null)} className="-ml-4" data-id="element-1561">
          Back to Payments
        </Button>
        <PageHeader title={`Remittance Advice: ${selectedPayment.id}`} description={`Payment Date: ${selectedPayment.date}`} primaryAction={<Button variant="secondary" leftIcon={<DownloadIcon className="w-4 h-4" data-id="element-1565" />} data-id="element-1564">
              Download PDF
            </Button>} data-id="element-1563" />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1566">
          <div className="lg:col-span-2 space-y-6" data-id="element-1567">
            <Card data-id="element-1568">
              <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-1569">
                Payment Details
              </h2>
              <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-1570">
                <div data-id="element-1571">
                  <span className="text-text-secondary block" data-id="element-1572">
                    Total Amount
                  </span>
                  <span className="font-medium text-lg" data-id="element-1573">
                    {selectedPayment.amount}
                  </span>
                </div>
                <div data-id="element-1574">
                  <span className="text-text-secondary block" data-id="element-1575">Status</span>
                  <StatusPill status={selectedPayment.status} className="mt-1" data-id="element-1576" />
                </div>
                <div data-id="element-1577">
                  <span className="text-text-secondary block" data-id="element-1578">
                    Payment Method
                  </span>
                  <span className="font-medium" data-id="element-1579">{selectedPayment.method}</span>
                </div>
                <div data-id="element-1580">
                  <span className="text-text-secondary block" data-id="element-1581">
                    Bank Account
                  </span>
                  <span className="font-medium" data-id="element-1582">DBS Bank ****6789</span>
                </div>
              </div>
            </Card>
            <Card data-id="element-1583">
              <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-1584">
                Included Invoices
              </h2>
              <DataTable data={[{
              inv: 'INV-2026-00087',
              po: 'PO-2026-00128',
              amount: selectedPayment.amount
            }]} columns={[{
              header: 'Invoice Number',
              accessorKey: 'inv',
              cell: row => <span className="font-medium text-fpg-navy cursor-pointer" data-id="element-1586">
                        {row.inv}
                      </span>
            }, {
              header: 'PO Reference',
              accessorKey: 'po'
            }, {
              header: 'Amount Applied',
              accessorKey: 'amount',
              align: 'right'
            }]} data-id="element-1585" />
            </Card>
          </div>
          <div className="space-y-6" data-id="element-1587">
            <Card className="bg-fpg-navy text-white" data-id="element-1588">
              <h2 className="text-lg font-semibold mb-2" data-id="element-1589">
                Early Payment Program
              </h2>
              <p className="text-sm text-white/80 mb-4" data-id="element-1590">
                Get paid faster by opting into our dynamic discounting program.
              </p>
              <Button variant="secondary" className="w-full text-fpg-navy" data-id="element-1591">
                View Offers
              </Button>
            </Card>
          </div>
        </div>
      </div>;
  }
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-1592">
      <PageHeader title="Payments" description="View remittance advice and scheduled payments." breadcrumbs={[{
      label: 'Home',
      href: '/supplier/dashboard'
    }, {
      label: 'Payments'
    }]} data-id="element-1593" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1594">
        <KPICard title="Paid This Month" value="$441.7K" icon={<DollarSignIcon className="w-5 h-5 text-status-success" data-id="element-1596" />} data-id="element-1595" />
        <KPICard title="Scheduled Payments" value="$112.4K" icon={<ClockIcon className="w-5 h-5 text-status-info" data-id="element-1598" />} data-id="element-1597" />
        <KPICard title="Held Payments" value="$0.00" icon={<CreditCardIcon className="w-5 h-5 text-text-tertiary" data-id="element-1600" />} data-id="element-1599" />
      </div>

      <Card data-id="element-1601">
        <div className="mb-4 flex justify-between items-center" data-id="element-1602">
          <h2 className="text-lg font-semibold text-text-primary" data-id="element-1603">
            Payment History
          </h2>
        </div>
        <DataTable data={payments} columns={[{
        header: 'Payment Reference',
        accessorKey: 'id',
        cell: row => <span className="font-medium text-fpg-navy" data-id="element-1605">{row.id}</span>
      }, {
        header: 'Date',
        accessorKey: 'date'
      }, {
        header: 'Amount',
        accessorKey: 'amount',
        align: 'right'
      }, {
        header: 'Method',
        accessorKey: 'method'
      }, {
        header: 'Invoices',
        accessorKey: 'invoices',
        align: 'center'
      }, {
        header: 'Status',
        cell: row => <StatusPill status={row.status} data-id="element-1606" />
      }]} onRowClick={setSelectedPayment} data-id="element-1604" />
      </Card>
    </div>;
};